import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { SessionStorageService } from '@common/services/storage/session-storage.service';

/**
 * Allow route access only for specified roles.
 *
 * Example:
 * const ROUTES: Routes = [
 *  {
 *    path: 'administrator',
 *    component: AdministratorComponent,
 *    canActivate: [ RoleGuard ],
 *    data: { expectedRoles: [ 'administrator' ] },
 *  }
 * ]
 */
@Injectable()
export class RoleGuard  {
    constructor(
        private router: Router,
        private storage: SessionStorageService
    ) {}

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        const expectedRoles = route.data.expectedRoles;
        const account = this.storage.namespace('account').get();

        if (
            expectedRoles &&
            account &&
            expectedRoles.indexOf(account.role.ui_module) < 0
        ) {
            this.router.navigate(['/error/403']).then(() => {});
            return false;
        }

        return true;
    }
}
